import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetPaymentMethodAccounts = () => {
    const send = useGenericSend();

    return useCallback(async (options: Types.TGetPaymentMethodAccountsRequest): Promise<Types.IPaymentMethodAccountsItem[]> => {
        const { data } = await send<Types.TGetPaymentMethodAccountsRequest, Types.IGetPaymentMethodAccountsResponse>({
            ID: 33011,
            responses: [33012, 33013],
            description: 'Get payment method accounts',
            hideAccountsWithoutInfo: true,
            ...options
        });

        return data?.payments?.method;
    }, [send]);
};
